// src/app/(dashboard)/dana/chat/layout.tsx
'use client';

import dynamic from 'next/dynamic';
import React from 'react';
import Grid from '@mui/material/Grid2';
import ChatHistoryPage from '@/components/pages/dana/ChatHistoryPage';

const PageContainer = dynamic(() => import('@/components/common/page-container'), { ssr: false });
const MainSection = dynamic(() => import('@/components/pages/profile/main-section'), { ssr: false });

export default function Layout({
    children
}: {
    children: React.ReactNode
}) {
    return (
        <PageContainer className="lg:pt-8 pt-3">
            <MainSection>
                <Grid container spacing={3} width="100%">
                    {/* left column: always your chat history */}
                    <Grid size={{ lg: 3.5, md: 12, sm: 12, xs: 12 }}>
                        <ChatHistoryPage />
                    </Grid>
                    {/* right column: whatever the child page is */}
                    <Grid container size={{ lg: 8.5, md: 12, sm: 12, xs: 12 }}>
                        {children}
                    </Grid>
                </Grid>
            </MainSection>
        </PageContainer>
    );
};
